<template>
	<div>
		<v-row class="my-5" align="center" justify="center">
			<v-col cols="12" sm="8" md="6" lg="4" xl="3">
				<v-alert
					v-model="errorMsgAlert"
					close-text="Close Alert"
					class="alert-text mb-5"
					color="error"
					dark
					dismissible
					ref="snackbarError"
				>
					{{ $t(errorMsg) }}
				</v-alert>

				<v-snackbar
					v-model="snackbar"
					class="mt-15"
					color="success"
					:timeout="timeout"
					top
				>
					<div class="text-center py-1" style="font-size: 16px">
						{{ $t(snackbarText) }}
					</div>

					<template v-slot:action="{ attrs }">
						<v-btn color="white" icon v-bind="attrs" @click="snackbar = false">
							<v-icon>mdi-close-circle</v-icon>
						</v-btn>
					</template>
				</v-snackbar>

				<p align="center" justify="center">
					<!-- <div placeholder="{{ 'Run Site' | translate }}"></div> -->
					<b>{{ $t(["Run Site"]) }}</b> {{ authStore.runSiteInfo.runSiteName }}
				</p>

				<template>
					<v-btn
						class="btn-text btn-multiline mb-6"
						color="primary"
						x-large
						block
						:disabled="sendReportLoading"
						@click="goToPage('registerAndDonate')"
					>
						<span class="text-wrap" translate>
							{{ $t(["Register and/or Donate"]) }}
						</span>
					</v-btn>
				</template>

				<template>
					<v-btn
						class="btn-text btn-multiline mb-6"
						color="primary"
						x-large
						block
						translate
						:disabled="sendReportLoading"
						@click="goToPage('newOrder')"
					>
						<span class="text-wrap" translate>
							{{ $t(["Order Merchandise"]) }}
						</span>
					</v-btn>
				</template>

				<template>
					<v-btn
						class="btn-text btn-multiline mb-6"
						color="primary"
						x-large
						block
						translate
						:disabled="sendReportLoading"
						@click="goToPage('orderStatus')"
					>
						<span class="text-wrap" translate>
							{{ $t(["Check Order Status"]) }}
						</span>
					</v-btn>
				</template>

				<template>
					<v-btn
						class="btn-text btn-multiline mb-6"
						color="primary"
						x-large
						block
						translate
						:disabled="sendReportLoading"
						@click="goToPage('refundLogin')"
					>
						<span class="text-wrap" translate>
							{{ $t(["Refunds"]) }}
						</span>
					</v-btn>
				</template>

				<!-- <template>
					<v-btn
						class="btn-text btn-multiline mb-6"
						color="primary"
						x-large
						block
						translate
						:loading="sendReportLoading"
						@click="sendReport()"
					>
						<span class="text-wrap" translate>
							{{ $t(["Send Report To Run Organizer"]) }}
						</span>
					</v-btn>
				</template> -->

				<template>
					<v-btn
						class="btn-text btn-multiline mb-6"
						color="primary"
						x-large
						block
						translate
						:loading="getSummaryLoading"
						@click="goToPage('summaryReport')"
					>
						<span class="text-wrap" translate>
							{{ $t(["Summary Report"]) }}
						</span>
					</v-btn>
				</template>

				<template>
					<v-btn
						class="btn-text btn-multiline"
						color="primary"
						x-large
						block
						translate
						@click="goToPage('videoTutorials')"
					>
						<span class="text-center text-wrap" translate>
							{{ $t(["Video Tutorials"]) }}
						</span>
					</v-btn>
				</template>
			</v-col>
		</v-row>

		<v-row justify="center">
			<v-btn
				class="btn-text mt-15"
				color="secondary"
				large
				outlined
				bottom
				translate
				:loading="logoutBtnLoading"
				@click="logout()"
			>
				{{ $t(["Logout"]) }}
			</v-btn>
		</v-row>
	</div>
</template>

<script>
import { Auth } from "aws-amplify";

import { useAuthenicationStore } from "../store/authenication";

export default {
	name: "Home",
	data: () => ({
		snackbar: false,
		snackbarText: "",
		timeout: 3000,
		errorMsgAlert: false,
		errorMsg: "",
		sendReportLoading: false,
		getSummaryLoading: false,
		logoutBtnLoading: false,
	}),
	setup() {
		const authStore = useAuthenicationStore();

		return {
			authStore,
		};
	},
	mounted() {
		if (this.$route.params.errorMsg != undefined) {
			this.errorMsgAlert = true;
			this.errorMsg = this.$route.params.errorMsg;
		}

		this.snackbar = this.$route.params.success;
		this.snackbarText = this.$route.params.message;
	},
	methods: {
		goToPage(page) {
			if (
				page == "refundLogin" &&
				this.$cookies.get("tff_authenicateRefundLogin")
			) {
				this.$router.push("/refundOverview").catch((error) => {
					console.warn(error.message);
				});
			} else {
				this.$router.push("/" + page).catch((error) => {
					console.warn(error.message);
				});
			}
		},
		// async sendReport() {
		// 	this.sendReportLoading = true;

		// 	try {
		// 		await Auth.currentSession().then(async (data) => {
		// 			await this.authStore
		// 				.sendReportApi(
		// 					{ runSiteId: data.accessToken.payload.username },
		// 					data.idToken.jwtToken
		// 				)
		// 				.then((response) => {
		// 					this.snackbar = true;
		// 					this.snackbarText = this.$gettext(
		// 						"Successfully sent report to run organizer"
		// 					);
		// 				});
		// 		});
		// 	} catch (error) {
		// 		this.errorMsgAlert = true;
		// 		this.errorMsg = error.message == undefined ? error : error.message;

		// 		this.$nextTick(() => {
		// 			const el = this.$el.querySelector("snackbarError");
		// 			this.$vuetify.goTo(-5, el);

		// 			return;
		// 		});
		// 	}

		// 	this.sendReportLoading = false;
		// },
		async logout() {
			this.logoutBtnLoading = true;

			await Auth.signOut()
				.then(() => {
					// Save a language preference in cookie before sign out
					this.$cookies.set("tff_language", this.$i18n.locale, "1h");

					this.$router.replace({ name: "Login" });
				})
				.catch((error) => {
					this.errorMsgAlert = true;
					this.errorMsg = error.message == undefined ? error : error.message;
				});

			this.logoutBtnLoading = false;
		},
	},
};
</script>

<style lang="scss" scoped></style>
